import { jwtDecode } from 'jwt-decode'

export default function (token) {
	return new Promise((resolve, reject) => {
		let decoded = {}
		try {
			decoded = jwtDecode(token)
		} catch (error) {
			reject(error)
		}
		resolve(decoded)
	})
}
